// Free delivery progress bar. T is the threshold in pence, so 2500 means 25 pounds.
(function () {
  var T = 2500;
  var total = null;
  var q = false;

  function money(p) {
    return '£' + (p / 100).toFixed(2);
  }

  function css() {
    if (document.getElementById('fsp-css')) return;
    var s = document.createElement('style');
    s.id = 'fsp-css';
    s.textContent = '.fsp{margin:0 0 12px;font-size:13px;line-height:1.35;text-align:center}.fsp__text{margin:0 0 6px}.fsp__track{height:4px;border-radius:2px;background:rgba(128,128,128,.25);overflow:hidden}.fsp__fill{display:block;height:100%;width:0;background:currentColor;transition:width .3s ease}.fsp--done .fsp__text{font-weight:700}';
    document.head.appendChild(s);
  }

  function makeBar() {
    var w = document.createElement('div');
    w.className = 'fsp';
    var t = document.createElement('p');
    t.className = 'fsp__text';
    var k = document.createElement('div');
    k.className = 'fsp__track';
    var f = document.createElement('span');
    f.className = 'fsp__fill';
    k.appendChild(f);
    w.appendChild(t);
    w.appendChild(k);
    return w;
  }

  function render() {
    if (total === null) return;
    css();
    var buttons = document.querySelectorAll('[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var parent = btn.parentNode;
      if (!parent) continue;
      var el = parent.querySelector('.fsp');
      if (!el) {
        el = makeBar();
        parent.insertBefore(el, btn);
      }
      var left = T - total;
      var msg = left > 0 ? 'You are ' + money(left) + ' away from free delivery' : 'Your order qualifies for free delivery';
      if (el.getAttribute('data-msg') !== msg) {
        el.setAttribute('data-msg', msg);
        el.querySelector('.fsp__text').textContent = msg;
        el.querySelector('.fsp__fill').style.width = Math.min(100, Math.round((total / T) * 100)) + '%';
        if (left > 0) {
          el.classList.remove('fsp--done');
        } else {
          el.classList.add('fsp--done');
        }
      }
    }
  }

  function schedule() {
    if (q) return;
    q = true;
    setTimeout(function () {
      q = false;
      render();
    }, 0);
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.total_price; schedule(); })
      .catch(function () {});
  }

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var p = nativeFetch.apply(window, arguments);
    var u = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    if (u.indexOf('/cart/') !== -1) {
      p.then(function () { setTimeout(refresh, 250); });
    }
    return p;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (typeof u === 'string' && u.indexOf('/cart/') !== -1) {
      this.addEventListener('load', function () { setTimeout(refresh, 250); });
    }
    return nativeOpen.apply(this, arguments);
  };

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }

  refresh();
})();
